var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdwords({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0182 2.77999C21.1312 1.11 17.4396 2.10102 15.7727 4.99352L0.810046 30.9589C-0.856747 33.8514 0.132386 37.55 3.01939 39.22C5.9064 40.89 9.59805 39.899 11.2649 37.0065L26.2277 11.0411C27.8945 8.1486 26.9053 4.44998 24.0182 2.77999Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.018 2.77996C22.6694 1.99993 21.1454 1.80076 19.734 2.10452C20.3334 2.2338 20.9232 2.45635 21.4827 2.77996C24.3697 4.44996 25.3589 8.14858 23.692 11.0411L8.72938 37.0064C7.84114 38.5478 6.37787 39.5489 4.76776 39.8954C7.26102 40.4332 9.9208 39.3383 11.2646 37.0064L26.2272 11.0411C27.8942 8.14858 26.905 4.44996 24.018 2.77996Z",
    fill: "#FFB300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02979 40.0314C9.35995 40.0314 12.0596 37.3266 12.0596 33.9902C12.0596 30.6537 9.35995 27.949 6.02979 27.949C2.69963 27.949 0 30.6537 0 33.9902C0 37.3266 2.69963 40.0314 6.02979 40.0314Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76777 39.8956C4.76744 39.8964 4.76727 39.897 4.76703 39.8977C5.1744 39.9846 5.59653 40.0314 6.02982 40.0314C9.35996 40.0314 12.0596 37.3267 12.0596 33.9902C12.0596 33.249 11.9257 32.5392 11.6819 31.8831L8.72947 37.0066C7.84115 38.548 6.37788 39.549 4.76777 39.8956Z",
    fill: "#43A047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1903 30.9588L26.2276 4.99352C24.5608 2.10102 20.8692 1.11 17.9821 2.77999C15.0951 4.44998 14.1059 8.14861 15.7727 11.0411L30.7355 37.0065C32.4023 39.899 36.0939 40.89 38.981 39.22C41.8679 37.55 42.8572 33.8513 41.1903 30.9588Z",
    fill: "#2196F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1903 30.9589L26.2276 4.99366C24.8838 2.66176 22.2241 1.5668 19.7308 2.10468C21.3409 2.45118 22.8042 3.45229 23.6925 4.99366L38.6552 30.959C40.3221 33.8515 39.3329 37.5501 36.4459 39.2201C35.8863 39.5437 35.2965 39.7663 34.6972 39.8956C36.1085 40.1993 37.6325 40.0002 38.9811 39.2201C41.868 37.5501 42.8572 33.8514 41.1903 30.9589Z",
    fill: "#1E88E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdwords);
export default __webpack_public_path__ + "static/media/adwords.1a83ee15c20eb1aacf6d554bcd7e7b36.svg";
export { ForwardRef as ReactComponent };